/**
 * De vastgezette scène "Zo werk ik": welke stap hoort bij hoeveel scroll. Puur, voor de test.
 *
 * `progress` = 0 bij het vastzetten, 1 bij het loslaten. Elke stap krijgt een even groot deel.
 */

/** Scrollafstand per stap, in schermhoogtes. Iets minder dan een scherm: doorlopend, niet traag. */
export const SCREENS_PER_STEP = 0.8

/** De actieve stap (0-gebaseerd). */
export function stepAt(progress: number, count: number): number {
  if (count <= 0) return 0
  const p = Math.min(Math.max(progress, 0), 1)
  return Math.min(count - 1, Math.floor(p * count))
}

/** Hoe vol het balkje van stap `index` is (0–1): vol voor eerdere stappen, leeg voor latere. */
export function segmentFill(progress: number, count: number, index: number): number {
  if (count <= 0) return 0
  const p = Math.min(Math.max(progress, 0), 1)
  return Math.min(Math.max(p * count - index, 0), 1)
}

/** Totale hoogte van het spoor waarin de scène vastzit: één scherm plus de scroll per stap. */
export const trackHeight = (count: number): string => `${Math.round((1 + count * SCREENS_PER_STEP) * 100)}svh`
